import styles from './EmptyTemplateContent.module.css';
import React from 'react';
import classNames from 'classnames';

interface EmptyContentProps {
    description: string;
}

export const EmptyTemplateContent: React.FC<EmptyContentProps> = ({
    description,
}) => {
    return (
        <div className={styles.blogSection}>
            <div
                className={classNames(
                    styles.blogMediaSection,
                    styles.fullWidthText,
                    styles.blogTextBlockOnly
                )}
            >
                <div className={styles.blogTextBlockOnly}>
                    <p
                        className={classNames(
                            styles.blogTextBlockP,
                            styles.blogTextBlockPOnly
                        )}
                        style={{
                            fontFamily: 'Roboto, sans-serif',
                            fontSize: '20px',
                        }}
                        dangerouslySetInnerHTML={{
                            __html: description,
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
